import { faExclamationTriangle } from "@fortawesome/pro-light-svg-icons";

import { T } from "@repo/transifex";

import { Modal } from "../shared/modal";
import { ModalIcon } from "../shared/modal-icon";
import { ModalTitle } from "../shared/modal-title";
import { ModalButton } from "../shared/modal-button";
import { ModalButtonGroup } from "../shared/modal-button-group";

export type ModalOutOfStockProduct = {
  id: string;
  name: string;
};

type ModalOutOfStockProps = {
  products: ModalOutOfStockProduct[];
  onBack: () => void;
  paymentReversed?: boolean;
};

export const ModalOutOfStock = ({
  products,
  onBack,
  paymentReversed = false
}: ModalOutOfStockProps) => {
  return (
    <Modal backdropVariant="error" open>
      <div className="flex flex-col items-center gap-16 px-32 text-center">
        <ModalIcon icon={faExclamationTriangle} variant="error" />

        <ModalTitle size="8xl" variant="error" weight="black">
          <T _str="Products unavailable" />
        </ModalTitle>

        <p className="text-6xl text-kiosk-text-white">
          <T _str="The following products are no longer available:" />
        </p>

        <ul className="flex list-disc flex-col gap-4 pl-[1.5em] text-left text-6xl font-bold text-kiosk-text-white">
          {products.map((product) => (
            <li key={product.id}>{product.name}</li>
          ))}
        </ul>

        <p className="text-6xl text-kiosk-text-white">
          <T _str="Remove them from your basket and try again." />
        </p>

        {paymentReversed ? (
          <p className="text-6xl text-kiosk-text-white">
            <T _str="Your payment has been reversed automatically." />
          </p>
        ) : null}

        <ModalButtonGroup className="mt-16">
          <ModalButton variant="error" onClick={onBack}>
            <T _str="Back to basket" />
          </ModalButton>
        </ModalButtonGroup>
      </div>
    </Modal>
  );
};
